import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import TableCell from '@material-ui/core/TableCell';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import IconButton from '@material-ui/core/IconButton';
//Ícones
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
//Componentes
import GenericListPage from './GenericListPage';
import { Link } from 'react-router-dom';
//Controller
import AvaliacaoController from '../controllers/AvaliacaoController';
import PermissaoController from '../controllers/PermissaoController';
//Modelos
import { STATUS_CANCELADA, STATUS_FINALIZADA, STATUS_INICIADA } from '../models/Avaliacao';
//Úteis
import deepCopy from '../utils/deepCopy';
import { formatarDataUTC } from '../utils/formatarData';

/**
 * Definindo o modelo Avaliacao
 * @typedef { import('../models/Avaliacao').default} Avaliacao
 */

/**
 * Componente para listar as avaliações
 */
class AvaliacaoListPage extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleFilter = this.handleFilter.bind(this);
        this.handleRenderItem = this.handleRenderItem.bind(this);
        this.handleRenderItemEditIcon = this.handleRenderItemEditIcon.bind(this);
        this.handleChange = this.handleChange.bind(this);
        //Controllers
        this.permissaoController = new PermissaoController();
        this.avaliacaoController = new AvaliacaoController();
        //Estado Inicializa
        this.state = {
            exibeAvaliador: false,
            questionario: '',
            avaliador: '',
            cliente: '',
            status: ''
        };
    }

    async componentDidMount() {
        //Consuta a permissão do usuário
        const exibeAvaliador = await this.permissaoController.permiteVisualizarTodasAvaliacoes();
        //Atualiza o estado da página
        this.setState({ exibeAvaliador });
    }

    /**
     * Evento disparado para obter os parâmetros do filtros
     * @return {Object} Retorna os parâmetros informados pelo usuário
     */
    handleFilter() {
        //Recupera os parâmetros preenchidos pelo usuário
        const { questionario, avaliador, cliente, status } = this.state;
        //Repassa os parâmetros para o filtro
        return { questionario, avaliador, cliente, status };
    }

    /**
     * Trata as alterações nos campos do formulário e atualiza o state
     * @param {*} event Objeto contendo os dados do evento
     */
    handleChange(event) {
        //Cria uma cópia do estado atual
        const state = deepCopy(this.state);
        //Atualiza somente o valor do campo alterado
        state[event.target.name] = event.target.value;
        //Atualiza o estado
        this.setState(state);
    }
    
    /**
     * Renderiza o ícone a ser exibido na linha do item
     * @param {Avaliacao} item Item a ser renderizado
     * @returns {React.Component} Retorna o ícone correspondente
     */
    handleRenderItemEditIcon(item) {
        if (item.status === STATUS_FINALIZADA)
            return (
                <IconButton aria-label="Visualizar" size="small" component={Link} to={`avaliacao/${item.id}`}>
                    <VisibilityIcon />
                </IconButton>
            );
        else
            return (
                <IconButton aria-label="Editar" size="small" component={Link} to={`avaliacao/${item.id}`}>
                    <EditIcon />
                </IconButton>
            );
    }

    /**
     * Renderiza um item da lista
     * @param {Avaliacao} item Item a ser renderizado
     * @returns {React.Component} Retorna a linha da tabela correspondente
     */
    handleRenderItem(item) {
        let status;
        if (item.status === STATUS_INICIADA)
            status = 'Iniciada';
        else if (item.status === STATUS_CANCELADA)
            status = 'Cancelada';
        else if (item.status === STATUS_FINALIZADA)
            status = 'Finalizada';

        return (
            <React.Fragment>
                <TableCell>{item.questionario.titulo}</TableCell>
                <TableCell>{item.cliente.nome}</TableCell>
                { this.state.exibeAvaliador && <TableCell>{item.avaliador.nome}</TableCell> }
                <TableCell>{status}</TableCell>
                <TableCell>{formatarDataUTC(item.dataCadastro)}</TableCell>
            </React.Fragment>
        );
    }

    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { exibeAvaliador, questionario, cliente, avaliador, status } = this.state;

        let columnNames = [ ];
        if (exibeAvaliador)
            columnNames = ['Questionário', 'Cliente', 'Avaliador', 'Status', 'Data'];
        else
            columnNames = ['Questionário', 'Cliente', 'Status', 'Data'];

        return (
            <GenericListPage resource="avaliacao" controller={this.avaliacaoController} columnNames={columnNames} onLogout={onLogout} onRenderItem={this.handleRenderItem} onRenderItemEditIcon={this.handleRenderItemEditIcon} usuario={usuario} empresa={empresa} permissoes={permissoes} onFilter={this.handleFilter} >
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} md={3} >
                                <TextField
                                    name="questionario"
                                    label="Questionário"
                                    type="text"
                                    placeholder="Título do questionário"
                                    variant="outlined"
                                    fullWidth
                                    value={questionario}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} >
                                <TextField
                                    name="cliente"
                                    label="Cliente"
                                    type="text"
                                    placeholder="Nome do cliente"
                                    variant="outlined"
                                    fullWidth
                                    value={cliente}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            {
                                exibeAvaliador &&
                                    <Grid item xs={12} sm={6} md={3} >
                                        <TextField
                                            name="avaliador"
                                            label="Avaliador"
                                            type="text"
                                            placeholder="Nome do avaliador"
                                            variant="outlined"
                                            fullWidth
                                            value={avaliador}
                                            onChange={this.handleChange}
                                        />
                                    </Grid>
                            }
                            <Grid item xs={12} sm={6} md={3} >
                                <FormControl fullWidth variant="outlined" >
                                    <InputLabel htmlFor="status">Status</InputLabel>
                                    <Select
                                        id="status"
                                        name="status"
                                        label="Status"
                                        native
                                        variant="outlined"
                                        fullWidth
                                        value={status}
                                        onChange={this.handleChange}
                                    >
                                        <option value=""></option>
                                        <option value={STATUS_INICIADA}>Iniciada</option>
                                        <option value={STATUS_FINALIZADA}>Finalizada</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} container justify="flex-end" >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </GenericListPage>
        );
    }
}

AvaliacaoListPage.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired
};


export default AvaliacaoListPage;
